var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    x: "0px",
    y: "0px",
    viewBox: "10.51 9.44 42.99 45.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.76,15.94v-5a1.5,1.5,0,0,0-3,0v5a6.76,6.76,0,0,0,0,13.18V53.05a1.5,1.5,0,1,0,3,0V29.12a6.76,6.76,0,0,0,0-13.18Zm-1.5,10.35A3.76,3.76,0,1,1,21,22.53,3.77,3.77,0,0,1,17.26,26.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5,34.88V10.95a1.5,1.5,0,0,0-3,0V34.88a6.76,6.76,0,0,0,0,13.18v5a1.5,1.5,0,1,0,3,0v-5a6.76,6.76,0,0,0,0-13.18ZM32,45.24a3.76,3.76,0,1,1,3.76-3.76A3.77,3.77,0,0,1,32,45.24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5,29.37a6.77,6.77,0,0,0-5.26-6.59V10.95a1.5,1.5,0,0,0-3,0V22.78a6.76,6.76,0,0,0,0,13.18V53.05a1.5,1.5,0,1,0,3,0V36A6.77,6.77,0,0,0,53.5,29.37Zm-6.76,3.76a3.76,3.76,0,1,1,3.76-3.76A3.77,3.77,0,0,1,46.74,33.13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.f62dbf9af892c79da92b76611664b158.svg";
export { ForwardRef as ReactComponent };